f = require 'effing'
PopOver = require 'views/lib/pop-over'
PopOverListComponent = require 'views/internal/pop-over-list-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'

module.exports = class extends React.Component
  displayName: 'SlackTeamComponent'

  changeAssociatedSlack: (el) ->
    { domain, id, name, selfJoin } = @props.team
    hasBC = @props.hasBC
    isAdmin = @props.isAdmin

    canChangeSelfJoin = hasBC && isAdmin

    PopOver.toggle
      elem: el
      getViewTitle: -> name
      reactElement: React.createElement PopOverListComponent,
        key: 'slack team linking'
        items: [
          {
            onClick: =>
              track('Slack Association', 'Unlink')
              PopOver.hide()
              @props.deleteSlackAssociation(id)
            content: t.render ->
              t.a href: "#", ->
                t.format 'unlink'
                t.span className: 'sub-name', ->
                  t.format 'this-trello-team-will-no-longer-be-linked-to-domain', { domain }
          }, {
            content: t.render ->
              t.hr()
          }, {
            content: t.render ->
              t.p ->
                t.format 'who-can-join-team'
          }, {
            onClick: =>
              if canChangeSelfJoin
                track('Slack Association', 'SelfJoin')
                PopOver.hide()
                @props.changeSlackSelfJoin(true, id)
            content: t.render ->
              t.a { class: t.classify(disabled: !canChangeSelfJoin), href: '#' }, ->
                t.format 'slack-self-join'
                if selfJoin
                  t.icon 'check'
                t.span className: 'sub-name', ->
                  t.format 'slack-team-members-can-join-team'
          }, {
            onClick: =>
              if canChangeSelfJoin
                track('Slack Association', 'InviteOnly')
                PopOver.hide()
                @props.changeSlackSelfJoin(false, id)
            content: t.render ->
              t.a { class: t.classify(disabled: !canChangeSelfJoin), href: '#' }, ->
                t.format 'slack-invite-only'
                if !selfJoin
                  t.icon 'check'
                t.span className: 'sub-name', ->
                  t.format 'slack-team-members-require-invite'
          }, {
            content: t.render ->
              t.div ->
                if !isAdmin
                  t.hr()
                  t.p '.helper', ->
                    t.format 'you-need-to-be-an-admin-to-change-this-setting'
                else if !hasBC
                  t.hr()
                  t.icon 'business-class', class: 'icon-business-class-color u-float-left'
                  t.p '.slack-bc-upsell', ->
                    t.format 'slack-upgrade-to-business-class'
          }
        ]

  render: t.renderable ->
    { icon, header, contents, canChange } = @props
    onChange = f(@, "changeAssociatedSlack")

    t.div '.window-module.u-clearfix.slack-team', ->

      t.div '.u-float-left', ->
        t.addElement icon

      t.div ->

        t.div '.slack-team-header', ->
          t.h3 '.u-inline', ->
            t.addElement header

        t.div '.slack-team-body', ->
          t.div '.slack-team-detail', ->
            t.addElement contents

          t.div '.slack-team-action', ->
            classes =
              'button-link': true
              'u-text-align-center': true
              disabled: !canChange
            t.b onChange, disabled: !canChange, class: t.classify(classes), ->
              t.format 'change'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/slack-team-component.coffee